//import node_modules
import React, { FunctionComponent } from "react";
import Link from "next/link";
import { format } from "date-fns/format";
import { Col, Button } from "react-bootstrap";

//libs
import { css } from "libs/emotion";

//types
import type { BlogDocument } from "@adjust/libs/database/blogs";

interface BlogPreviewProps {
  blog: BlogDocument;
  order: number;
}

const clickableCSS = css({
  color: "black",
  textDecoration: "none",

  [":hover"]: {
    color: "black",
    textDecoration: "underline",
  },
});

const containerCSS = css({
  display: "flex",
  textAlign: "center",
  flexDirection: "column",
  fontFamily: "DM Sans, sans-serif",
  margin: "16px",
});

const InformationComponent: FunctionComponent<BlogPreviewProps> = ({ blog, order }) => {
  return (
    <Col xs={{ order: 2, span: 12 }} lg={{ order: order, span: 4 }}>
      <div className={containerCSS}>
        <Link href={`/blog/${blog.slug}`} className={clickableCSS}>
          <p className="h2 mb-3">{blog.title}</p>
        </Link>
        <div className="h5">{format(blog.publishedTime, "PPP")}</div>
        <p className="h4">{blog.description}</p>
        <div className="my-auto" />
        <div>
          <Link href={`/blog/${blog.slug}`} legacyBehavior passHref>
            <Button variant="outline-primary" size="lg">
              READ THE POST
            </Button>
          </Link>
        </div>
      </div>
    </Col>
  );
};

export default React.memo(InformationComponent);
